// TODO: Make this more sophisticated by
// providing padding and dyanmically working out
// distance between objects based on their size.

import {
  AlignLayoutGroupCenter,
  AlignLayoutGroupLeft,
  AlignLayoutGroupRight,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserLayout/LayoutGroupUtils';
import MinigameCardSlot from '@/game/prefabs/StudentGame/MinigameCardSlot';

// Initially, elements are all just center-aligned.
export interface LayoutGroupData {
  parent: Phaser.GameObjects.Container;
  origin: Phaser.Math.Vector2;
  elementDist: number;
  align: 'center' | 'left' | 'right';
  realignmentType?: 'instant' | 'animated';
  maxWidth?: number;
}

export class HorizontalLayoutGroup {
  data: LayoutGroupData;
  isRealigning: boolean = false;
  rowCount = 0;

  constructor(data: LayoutGroupData) {
    this.data = data;
    this.updateLayout();
  }

  getElementList() {
    return this.data.parent.list;
  }

  addElement(element: Phaser.GameObjects.GameObject) {
    this.data.parent.add(element);
    this.updateLayout();
  }

  removeElement(element: Phaser.GameObjects.GameObject) {
    this.data.parent.remove(element);
    element.destroy();
    this.updateLayout();
  }

  removeLastElement() {
    this.removeElement(this.data.parent.list[this.data.parent.list.length - 1]);
  }

  moveElement(element: Phaser.GameObjects.GameObject, index: number) {
    this.data.parent.moveTo(element, index);
    this.updateLayout();
  }

  clear() {
    const elementsToDestroy = [...this.data.parent.list];
    elementsToDestroy.forEach((element) => {
      element.destroy();
    });
    this.data.parent.list = [];
    this.updateLayout();
  }

  updateLayout() {
    switch (this.data.align) {
      case 'center':
      default:
        AlignLayoutGroupCenter(this);
        break;
      case 'left':
        AlignLayoutGroupLeft(this);
        break;
      case 'right':
        AlignLayoutGroupRight(this);
        break;
    }
  }

  public positionElement(
    element: Phaser.GameObjects.GameObject &
      Phaser.GameObjects.Components.Transform,
    x: number,
    y: number,
    realignmentTypeOverride?: 'instant' | 'animated',
  ) {
    this.isRealigning = true;
    // Special case slots. Not ideal.
    if (element instanceof MinigameCardSlot) {
      realignmentTypeOverride = 'instant';
    }
    const { data } = this;
    switch (realignmentTypeOverride || data.realignmentType) {
      case 'instant':
      default:
        element.setPosition(x, y);
        this.isRealigning = false;
        break;
      case 'animated':
        data.parent.scene.tweens.add({
          targets: element,
          x: x,
          y: y,
          duration: 200,
          ease: 'Cubic.easeOut',
          onComplete: () => {
            this.isRealigning = false;
          },
        });
    }
  }

  setAlignment(align: 'center' | 'left' | 'right') {
    this.data.align = align;
    this.updateLayout();
  }
}
